import { useQuery } from '@apollo/client'
import React, { useEffect, useState, useRef } from 'react'
import { Link } from 'react-router-dom'
import HorizontalContainer from '../../components/HorizontalContainer'
import { Box, Flex, Image } from 'rebass/styled-components'
import { GET_COLLECTIONS } from '../../graphql/queries'
import { storage } from '../../utils/index'
import CategoryCube from '../../components/CategoryCube'
import Carousel from '../../components/Carousel'
import IonContent from '../../components/IonContent'
import Prismic from '@prismicio/client'
import Divider from '../../components/Divider'
import {
    IonLoading,
    IonSearchbar,
    IonToolbar,
    IonPage,
    IonTitle,
    IonRouterLink,
    IonButtons,
    IonButton,
    IonHeader,
    IonPopover,
    IonText,
} from '@ionic/react'

const HomeHead = ({ logo }) => {
    const [popoverState, setShowPopover] = useState({ showPopover: false, event: undefined })

    return (
        <IonHeader>
            <IonToolbar>
                <Flex alignItems="center" px="10px" justifyContent="space-between">
                    <IonButtons slot="start">
                        <Image width="auto" maxWidth="102px" src={logo || '/logo192.png'} alt="" />
                    </IonButtons>

                    <Flex
                        as={Link}
                        flex="1"
                        to="/search"
                        sx={{
                            'ion-searchbar': {
                                'padding-inline-end': 0,
                            },
                        }}
                    >
                        <IonSearchbar></IonSearchbar>
                    </Flex>

                    <IonPopover
                        cssClass="my-custom-class"
                        event={popoverState.event}
                        isOpen={popoverState.showPopover}
                        onDidDismiss={() =>
                            setShowPopover({ showPopover: false, event: undefined })
                        }
                    >
                        <p>This is popover content</p>
                    </IonPopover>
                    <span></span>
                    {/* <IonText
                        slot="end"
                        onClick={e => {
                            e.persist()
                            setShowPopover({ showPopover: true, event: e })
                        }}
                    >
                        English
                    </IonText> */}
                </Flex>
            </IonToolbar>
        </IonHeader>
    )
}

export default () => {
    const [info, setInfo] = useState({})

    useEffect(() => {
        const getDataBackend = async () => {
            var apiEndpoint = 'https://fruitstore.cdn.prismic.io/api/v2'
            const client = Prismic.client(apiEndpoint)
            const prismic = await client.query('')
            storage.setItem('prismic', prismic)
            return prismic
        }
        const initData = async () => {
            let res = storage.getItem('prismic')
            if (!res) {
                res = await getDataBackend()
            }
            if (res.results) {
                setInfo({
                    logo: res.results.find((x) => x.type === 'logo')?.data,
                    banner: res.results.find((x) => x.type === 'banner')?.data,
                    category: res.results.find((x) => x.type === 'category')?.data,
                    promotion: res.results.find((x) => x.type === 'promotion')?.data,
                })
                await getDataBackend()
            }
        }
        initData()
    }, [])

    const { loading, error, data = {} } = useQuery(GET_COLLECTIONS, {
        variables: {
            limit: 50,
        },
    })

    const collections = data.collections?.edges?.filter(({ node }) =>
        info.category?.categories?.some((x) => x.handle === node.handle)
    )

    return (
        <IonPage>
            <HomeHead logo={info.logo?.url?.url}></HomeHead>
            <IonContent>
                <Carousel
                    data={info.banner?.banners?.map((x) => ({
                        handle: x.handle,
                        src: x.url.url,
                    }))}
                    withLink={true}
                ></Carousel>
                <CategoryCube collections={collections} />
                {info.promotion?.promotions?.map((item) => (
                    <HorizontalContainer key={item.handle} {...item} />
                ))}
                <IonLoading isOpen={loading} />
            </IonContent>
        </IonPage>
    )
}
